import { useEffect } from "react";
import Preloader from "@/components/layout/Preloader";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import BrandPhilosophy from "@/components/sections/BrandPhilosophy";
import PurposeVisionMission from "@/components/sections/PurposeVisionMission";
import PuzzlePillars from "@/components/sections/PuzzlePillars";
import Services from "@/components/sections/Services";
import CapabilityUniverse from "@/components/sections/CapabilityUniverse";
import MaterialsCraftFinish from "@/components/sections/MaterialsCraftFinish";
import Process from "@/components/sections/Process";
import WhyKrister from "@/components/sections/WhyKrister";
import KristerKreatid from "@/components/sections/KristerKreatid";
import FinalDoctrine from "@/components/sections/FinalDoctrine";
import ContactQuote from "@/components/sections/ContactQuote";

const Home = () => {
  useEffect(() => {
    // Guarantee no scroll position from React Router on first render
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, []);

  return (
    <main data-testid="home-page" style={{ background: "#0A0A0A" }}>
      <Preloader />
      <Navbar />
      <Hero />
      <BrandPhilosophy />
      <PurposeVisionMission />
      <PuzzlePillars />
      <Services />
      <CapabilityUniverse />
      <MaterialsCraftFinish />
      <Process />
      <WhyKrister />
      <KristerKreatid />
      <FinalDoctrine />
      <ContactQuote />
      <Footer />
    </main>
  );
};

export default Home;
